import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=138853a4&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"
import style0 from "./mobile.scss?vue&type=style&index=0&id=138853a4&prod&scoped=true&lang=scss&external"
import style1 from "./Mobile.vue?vue&type=style&index=1&id=138853a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138853a4",
  null
  
)

export default component.exports